// extracted by mini-css-extract-plugin
export var fadeInAnimation = "FormStep-module--fadeInAnimation--98203";
export var scrollArea = "FormStep-module--scrollArea--86814";
export var stepWrapper = "FormStep-module--stepWrapper--0d46f";
export var title = "FormStep-module--title--f9142";